import React from 'react';
import { Stack, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ClientStatusBadges = ({ isAssignedToMe, hasActiveConversation }) => {
  const { t } = useTranslation();

  if (!isAssignedToMe && !hasActiveConversation) return null;

  return (
    <Stack direction="row" spacing={0.5} justifyContent="flex-end" sx={{ mb: 1 }}>
      {isAssignedToMe && (
        <Chip
          label={t('clients.assignedToMe')}
          size="small"
          sx={{
            height: 20,
            bgcolor: (theme) => theme.alpha((theme.vars || theme).palette.primary.main, 0.12),
            color: 'primary.main',
            '& .MuiChip-label': { px: 1 },
          }}
        />
      )}
      {hasActiveConversation && (
        <Chip
          label={t('clients.activeConversation')}
          size="small"
          sx={{
            height: 20,
            bgcolor: (theme) => theme.alpha((theme.vars || theme).palette.success.main, 0.12),
            color: 'success.main',
            '& .MuiChip-label': { px: 1 },
          }}
        />
      )}
    </Stack>
  );
};

export default ClientStatusBadges;
